// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__wCwZz","slider-glide-in":"Sidebar_slider-glide-in__6y2YK"};